module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/artillery-battalion-lvl2-75.b78cf0fe.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/artillery-battalion-lvl2-75.png
// module id = 3501
// module chunks = 11